import { MarketPosturaBody } from 'src/solace';

export class MarketPostura {
  body: MarketPosturaBody[];
}
